export const UPSIZE_ITEM_SLIDER_WIDTH = 350;
export const UPSIZE_ITEM_WIDTH = 170;
export const UPSIZE_ITEMS_LIMIT_BEFORE_LOOP = 2;
